import { useMutation, useQueryCache } from "react-query";
import { API_KEY_GET_FRODER, API_KEY_GET_FRODERS_LIST } from "../constants";
import { _t } from "../../../../../modules/Common/components/InjectIntlContext";
import { notify } from "../../../../../system/utils/notification";
import { postFroder } from "../api";

export const usePostFroder = (id) => {
  const successMessage = _t("successfully_sent");
  const queryCache = useQueryCache();

  return useMutation(postFroder, {
    onSuccess: (data, variables) => {
      queryCache.invalidateQueries(API_KEY_GET_FRODER, id);
      queryCache.invalidateQueries(API_KEY_GET_FRODERS_LIST);
      notify("success", successMessage);
    },
  });
};
